import { render, staticRenderFns } from "./ipFilterConfig.vue?vue&type=template&id=288b2444&scoped=true&"
import script from "./ipFilterConfig.vue?vue&type=script&lang=js&"
export * from "./ipFilterConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b2444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288b2444')) {
      api.createRecord('288b2444', component.options)
    } else {
      api.reload('288b2444', component.options)
    }
    module.hot.accept("./ipFilterConfig.vue?vue&type=template&id=288b2444&scoped=true&", function () {
      api.rerender('288b2444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/ipFilterConfig.vue"
export default component.exports